<ng-container
  *ngIf="homepageBannerFetchingError$ | async; else sliderHompageBanner">
  <rd-anz-banner> </rd-anz-banner>
</ng-container>

<ng-template #sliderHompageBanner>
  <rd-anz-homepage-banner> </rd-anz-homepage-banner>
</ng-template>

<anz-alert-banner
  *ngFor="let alert of (activeAlertBanners$ | async) ?? []"
  class="lg:screen-max-size mx-4 my-6 lg:mx-auto lg:my-8"
  [alert]="alert"></anz-alert-banner>
<div
  class="padding-until-widescreen lg:screen-max-size my-6 flex"
  *ngIf="promocodeBanner$ | async as promocodeBanner">
  <anz-promocode-banner [promocodeBanner]="promocodeBanner">
    <rd-shared-button
      class="button focus-link mt-5 max-w-fit"
      [buttonText]="promocodeBanner.buttonCopy"
      [buttonTheme]="'primary'"
      [redirectURL]="promocodeBanner.buttonUrl">
    </rd-shared-button>
  </anz-promocode-banner>
</div>
<rd-anz-benefits
  class="lg:screen-max-size mx-4 mt-5 pb-6 lg:mx-auto lg:mt-6 lg:pb-10"></rd-anz-benefits>
<anz-campaign-banner-home
  class="padding-until-widescreen lg:screen-max-size flex"></anz-campaign-banner-home>
<rd-anz-featured-partners
  class="mb-1 mt-11 lg:mb-14 lg:mt-12"></rd-anz-featured-partners>
<rd-anz-quick-access
  class="mb-14"
  [authRenderState]="authRenderState"></rd-anz-quick-access>
